import { render, staticRenderFns } from "./TurboShop.vue?vue&type=template&id=07afe047&scoped=true"
import script from "./TurboShop.vue?vue&type=script&lang=js"
export * from "./TurboShop.vue?vue&type=script&lang=js"
import style0 from "./TurboShop.vue?vue&type=style&index=0&id=07afe047&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07afe047",
  null
  
)

export default component.exports